import React, { StatelessComponent } from 'react';
import b from 'b_';

import Rect from '@components/rect';

import './banner.css';

const class_ = b.with('banner-stub');

const BannerStub: StatelessComponent = () => {
    return (
        <div className={class_()}>
            <Rect height={424} />
        </div>
    );
};

export default BannerStub;
